document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
    });
  });

  document.querySelectorAll('[data-product-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const mainImage = document.querySelector('[data-product-main-image]');
      if (!mainImage) return;
      mainImage.src = button.dataset.src;
      mainImage.srcset = button.dataset.srcset || '';
      mainImage.alt = button.dataset.alt || '';
      document.querySelectorAll('[data-product-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const idInput = form && form.querySelector('input[name="id"]');
      const price = document.querySelector('[data-product-price]');
      const button = form && form.querySelector('[data-add-to-cart]');
      if (idInput) idInput.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? button.dataset.availableText : button.dataset.soldText;
      }
    });
  });
});
